import fetcher from '../../fetcher';

const updateGitCommitMessage = async (analysisId, gitCommitMessage) =>
    await fetcher(`/analyses/${analysisId}/rename`, 'PUT', { gitCommitMessage });

export default updateGitCommitMessage;
